export default "__VITE_ASSET__DT$YLDzw__"